import React from 'react'
import PropTypes from 'prop-types'
import {Container, Row, Col} from 'react-bootstrap'
import parse from 'html-react-parser';
import { useStaticQuery, graphql, Link } from "gatsby"
import Heading from '../../../components/ui/heading'
import Text from '../../../components/ui/text'
import Button from '../../../components/ui/button'
import Image from '../../../components/image'
import {AssuranceWrap, ImageWrap, CaseStudyTextWrap, ButtonWrap} from './assurance.style'

const Aggregator = ({titleStyle, textStyle, product}) => {
    const qdata = useStaticQuery(graphql `
    query CaseQuery4{
        img: file(relativePath: { eq: "shield.png" }) {
        
            childImageSharp {
              fluid(maxWidth: 922, maxHeight: 760, quality: 100){
                presentationWidth
                presentationHeight
                ...GatsbyImageSharpFluid
              }
            }

        }
    }      
    `);
    //console.log(3434334)
    //console.log(qdata)
    const data = qdata.img;
    const imageFluid = qdata.img.childImageSharp.fluid;

    return (
        <AssuranceWrap>
        <Row>
            <Col lg={7}>
                  <Heading {...titleStyle}>
                      {/*Vi jobber med alle de vesentligste&raquo;
                      <span>garantiutstederne</span> i markedet*/}
                      Prisingen fra tilbyder til tilbyder varierer - det lønner seg å <span>sammenligne priser</span>...
                  </Heading>
                  <Text {...textStyle}>
                      Markedet for {product.toLowerCase()}er utstedt av forsikringsselskaper er i liten grad standardadisert når det kommer til pris.
                      Det betyr at prisingen fra leverandør til leverandør for samme garanti ofte kan variere relativt mye.
                      Vi innhenter pris fra de leverandører som er villige til å utstede {product.toLowerCase()}er
                      tilpasset deres bedrifts behov - slik at dere kan sammenligne tilbudene.
                  </Text>
            </Col>

            <Col lg={5}>
                <Heading {...titleStyle}>
                  {/*Vi jobber med alle de vesentligste&raquo;
                        <span>garantiutstederne</span> i markedet*/}
                  ...men <span>vilkårene er de samme</span> uavhengig av utsteder
                </Heading>
                <Text {...textStyle}>
                  Om en innhenter flere tilbud på {product.toLowerCase()}er er garantivilkårene
                  de samme, uavhengig av leverandør. Dette betyr at en kan nøye seg med å sammenligne pris,
                  og velge det billigste alternativet for et gitt garantibehov.
                </Text>
              {/*<ButtonWrap>
                      <Button as={Link} to={data.path}>Sammenlign tilbud på {product.toLowerCase()}er &raquo;</Button>
                  </ButtonWrap>*/}
            </Col>

        </Row>
        </AssuranceWrap>
    )
}

Aggregator.propTypes = {
    titleStyle: PropTypes.object
}

Aggregator.defaultProps = {
    titleStyle: {
        as:"h3",
        child: {
            color: 'primary'
        }
    },
    textStyle: {
        mt: '30px'
    }
}

export default Aggregator;
